import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withRoomContext } from '../../../../RoomContext';
// import { useIntl } from 'react-intl';
import { useIntl } from 'react-intl';
import { permissions } from '../../../../permissions';
import { makePermissionSelector } from '../../../../store/selectors';
import { Grid, LinearProgress, TextField } from '@material-ui/core';
import 'draft-js/dist/Draft.css';
import * as toolareaActions from '../../../../store/actions/toolareaActions';
// import './styles.css';
import EmojiPicker, { EmojiStyle } from 'emoji-picker-react';
import { ToastContainer, toast } from 'react-toastify';
import * as fileActions from '../../../../store/actions/fileActions';
import randomString from 'random-string';
import { useLocation } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import { config } from '../../../../config';

const styles = (theme) => ({
	input :
	{
		display        : 'flex',
		flex           : 1,
		'&[type=file]' : {
			display : 'none'
		},
		// padding         : '8px',
		lineHeight      : '20px',
		fontSize        : '16px',
		width           : '100%',
		height          : '100%',
		overflowWrap    : 'break-word',
		borderRadius    : '4px',
		backgroundColor : '#ffffff'
		// overflow        : 'scroll'

	},
	icon : {
		padding : theme.spacing(1)
	}
});

const BroadcastInput = (props) =>
{
	const {
		roomClient,
		displayName,
		peerId,
		email,
		picture,
		canChat,
		canShare,
		classes,
		browser,
		canShareFiles,
		chat,
		files,
		toolAreaOpen,
		templateIsFileShare,
		templateSendFiles,
		hasInputFileShare,
		templateChatMsgs,
		isModerator,
		hostControlSendChat,
		hostControlSendFiles,
		addBroadcastFile,
		webinarUser,
		isMobile,
		webinarData,
		socketId, replyData, setReplyData
	} = props;

	const intl = useIntl();
	const chatItemsLength = files.count + chat.messages.length;
	const location = useLocation();

	const urlParser = new URL(window.location);

	const parameters = urlParser.searchParams;
	const [ loader, setLoader ] = useState(false);
	const [ message, setMessage ] = useState('');
	const [ showEmojis, setShowEmojis ] = useState(false);
	const [ enterEnable, setEnterDisable ] = useState(false);
	const [ roomId, setRoomId ] = useState(
		decodeURIComponent(location.pathname.slice(1)) ||
		randomString({ length: 8 }).toLowerCase()
	);

	const inputRef = useRef();
	const emojiRef = useRef();

	const Clickout = (eve) =>
	{
		if (emojiRef.current?.contains(eve.target))
		{
			return;
		}
		setShowEmojis(false);
	};

	useEffect(() =>
	{
		document.addEventListener('mousedown', Clickout);

		return () =>
		{
			document.removeEventListener('mousedown', Clickout);
		};
	}, []);

	const handleSendMessage = async (body) =>
	{
		if (webinarUser)
		{
			if (webinarData?.chatVisibility==='attendees')
			{
				await roomClient.sendBroadcastChatMessage(body);
			}
			else if (webinarData?.chatVisibility==='host')
			{
				roomClient.updateSocketChat(body);
				await roomClient.sendMsgConfig('msgToHost', body);
			}
			else if (webinarData?.chatVisibility==='panelists')
			{
				roomClient.updateSocketChat(body);
				await roomClient.sendMessageToPanelists(body);
			}
		}
		else
		if (replyData)
		{
			setReplyData(null);
			await roomClient.sendBroadcastChatMessage(body, { socketId: replyData?.socketId });
		}
		else
		if (!isModerator)
		{
			await roomClient.sendMsgToWebinarUsers(body);
		}
		else
		{
			await roomClient.sendBroadcastChatMessage(body);
		}

	};

	const sendMessage = async () =>
	{
		if (message.trim() !== '')
		{

			const body = {
				userId         : window.btoa(email),
				meetingId      : webinarUser ? parameters.get('sessionId') : roomId,
				message        : message?.replace(/</g, '&lt;').replace(/>/g, '&gt;'),
				sendTime       : new Date().valueOf(),
				sender         : webinarUser ? 'Guest' : 'Host',
				userName       : displayName,
				type           : 'message',
				chatVisibility : webinarData?.chatVisibility,
				webinarUser    : true,
				isRead         : false
			};

			if (webinarUser)
			{
				body['socketId']=socketId;
			}

			if (replyData)
			{
				body['replyTo']=replyData.userId;
				body['replyData']=replyData;
			}

			handleSendMessage(body);

			setMessage('');
		}
	};

	const attachFile = async (e) =>
	{
		if (e.target.files.length > 0)
		{
			await props.roomClient.shareFiles({
				type       : 'file',
				time       : Date.now(),
				sender     : 'response',
				isRead     : null,
				name       : displayName,
				peerId     : peerId,
				picture    : picture,
				attachment : e.target.files
			});
		}
	};

	const getFileType = (fileName) =>
	{
		const extension = fileName?.split('.').pop();

		switch (extension)
		{
			case 'pdf':
				return 'pdf';
			case 'xlsx':
				return 'xlsx';
			case 'xls':
				return 'xls';
			case 'docx':
				return 'docx';
			case 'doc':
				return 'doc';
			case 'pptx':
				return 'pptx';
			case 'ppt':
				return 'ppt';
			case 'jpg':
			case 'jpeg':
			case 'png':
			case 'gif':
				return 'image';
			case 'mp3':
			case 'wav':
				return 'audio';
			case 'mp4':
			// case 'mov':
			// case 'mkv':
			// case '3gp':
			// case 'webm':
				return 'video';
			case 'txt':
			case 'csv':
				return 'text';
			default:
				return null;
		}
	};

	const handleAttachFile = async (e) =>
	{
		setLoader(true);
		// attachFile(e);
		const file = e.target.files[0];

		const filType=getFileType(file?.name);

		if (filType)
		{
			if (file?.size <= 50 * 1024 *1024)
			{
				try
				{
					// const formData = new FormData();

					// formData.append('file', file);

					await roomClient.uploadFileToS3(file, filType==='image'?'public/chatHistory/images':'public/chatHistory/files').then(async (res) =>
					{
						const uploadDoc={
							type     : 'file',
							fileType : filType,
							time     : Date.now(),
							sender   : 'response',
							url      : res.url,
							key      : res.key,
							fileName : file.name,
							size     : file.size,
							isRead   : null,
							name     : displayName,
							peerId   : peerId,
							picture  : picture
							// text     : message
						};

						addBroadcastFile(uploadDoc);

						const body = {
							userId         : window.btoa(email),
							meetingId      : webinarUser ? parameters.get('sessionId') : roomId,
							sendTime       : new Date().valueOf(),
							sender         : webinarUser ? 'Guest' : 'Host',
							userName       : displayName,
							type           : 'file',
							fileType       : filType,
							picture        : picture,
							url            : res.url,
							key            : res.key,
							fileName       : file.name,
							size           : file.size,
							webinarUser    : true,
							chatVisibility : webinarData?.chatVisibility,
							isRead         : false
						};

						if (webinarUser)
						{
							body['socketId']=socketId;
						}

						if (replyData)
						{
							body['replyTo']=replyData.userId;
							body['replyData']=replyData;
						}

						handleSendMessage(body);

						toast.success(intl.formatMessage({ id: 'File_uploaded_successfully', defaultMessage: 'File uploaded successfully' }), {
							position : toast.POSITION.TOP_RIGHT
						});
						setLoader(false);
					})
						.catch((err) =>
						{
							setLoader(false);
							toast.error(intl.formatMessage({ id: 'something_went_wrong', defaultMessage: 'Something went wrong.' }), {
								position : toast.POSITION.TOP_RIGHT
							});
						});

					// setUploadData([ uploadDoc ]);

				}
				catch (error)
				{
					console.error('Error uploading file to S3:', error);
					toast.error(intl.formatMessage({ id: 'Error_sending_file', defaultMessage: 'Error sending file...' }), {
						position : toast.POSITION.TOP_RIGHT
					});
					setLoader(false);
				}
			}
			else
			{
				toast.error(intl.formatMessage({ id: 'File_size_exceeds_50MB_limit', defaultMessage: 'File size exceeds 50MB limit' }));
				setLoader(false);
			}
		}
		else
		{
			toast.error(intl.formatMessage({ id: 'Unsupported_file_format', defaultMessage: 'Unsupported file format' }));
			setLoader(false);
		}
	};

	const handleChatEmojis = (
		emojiData,
		e,
		fontName = 'Twemoji Country Flags',
		fontUrl = 'https://cdn.jsdelivr.net/npm/country-flag-emoji-polyfill@0.1/dist/TwemojiCountryFlags.woff2'
	) =>
	{
		e.stopPropagation();

		const style = document.createElement('style');

		style.textContent = `@font-face {
			  font-family: "${fontName}";
			  unicode-range: U+1F1E6-1F1FF, U+1F3F4, U+E0062-E0063, U+E0065, U+E0067,
		 		U+E006C, U+E006E, U+E0073-E0074, U+E0077, U+E007F;
			  src: url('${fontUrl}') format('woff2');
			  font-display: swap;
			}`;
		document.head.appendChild(style);

		setMessage((prevState) => (prevState + emojiData?.emoji));
		inputRef.current.focus();
	};

	const preview = {
		showPreview : false
	};
	const handleEmojisEnter = (e) =>
	{
		if (e.key === 'Enter')
		{
			setShowEmojis(false);
			sendMessage();
		}
	};

	const customEmoji = {
		activeSkinTone : 'neutral',
		emoji          : '🫠',
		names          : [ 'custom_emoji' ],
		unified        : '1fae0',
		// You may need to provide an image URL if the picker requires it
		getImageUrl    : () =>
		{
		// Replace 'custom_emoji_image_url' with the actual image URL for the emoji
			return 'custom_emoji_image_url';
		}
		// Add any other required properties
	};
	const handleMessage = (e) =>
	{
		if (e.target.value.trim().length<=4000)
		{
			setMessage(e.target.value);
		}
		else
		{
			toast.dismiss();
			toast.error(intl.formatMessage({ id: 'message_length_exceeds', defaultMessage: 'Message length exceeds the maximum limit of 4000 characters.' }));
		}
	};
	const handleEnter = (e) =>
	{
		if (e.key === 'Enter' && !e.shiftKey && message.trim() !== '')
		{
			e.preventDefault();
			setEnterDisable(true);
			sendMessage();
			setTimeout(() =>
			{
				setEnterDisable(false);
			}, 500);
		}
	};

	const handleKeyPress = (e) =>
	{
		if (e.key === 'Enter')
		{
			e.preventDefault();
		}
	};

	useEffect(() =>
	{
		if (replyData && inputRef.current)
		{
			document.getElementById('message-container').focus();
			inputRef.current.focus(); // Focus the input field when replyData is set
		}
	}, [ replyData, inputRef.current ]);

	return (
		<div className='flexCol pdngXS'>
			{loader && (<LinearProgress />)}
			{!isModerator && !hostControlSendChat && !webinarUser ?
				<Grid className={classes.pdng} item container direction='column' justifyContent='center' alignItems='center'>Chat input is disabled by host</Grid>
				:
				<div className='flexRow InputCntnr aCntr'>
					{(roomClient?._roomTemplate?.data?.fileSharing || webinarUser) &&
						<div className='flexAutoCol pRel pdngXS '>
							{/* <label className='file_btn' htmlFor='contained-button-file'> */}
							<img className='pointer icons1' src='icons/add.svg' alt='icons'
								onClick={(e) => (e.target.value = null)}
								onMouseDown={(e) => e.preventDefault()}
							/>
							{/* </label> */}
							{isModerator ?
								<input
									id='contained-button-file'
									className='file_input'
									disabled={!canShare || (!hostControlSendFiles && !hasInputFileShare)}
									type='file'
									title=''
									multiple
									value=''
									onChange={handleAttachFile}
									onKeyDown={handleKeyPress}
									onClick={(event) =>
									{
										event.target.value = null;
									}}
								/>
								:
								(hostControlSendFiles || webinarUser) &&
								<input
									id='contained-button-file'
									className='file_input'
									disabled={(!canShare || !hasInputFileShare) && !webinarUser}
									type='file'
									title=''
									multiple
									onChange={handleAttachFile}
									value=''
									onKeyDown={handleKeyPress}
									onClick={(event) =>
									{
										event.target.value = null;
									}}
								/>
							}
						</div>
					}
					<div className='flexMinWidthRow'>
						<TextField className='chatInput' rowsMax={3} fullWidth ref={inputRef} value={message} placeholder={intl.formatMessage({ id: 'type_Something', defaultMessage: 'Type Something' })} autoFocus id='message-container' onChange={handleMessage} onKeyDown={handleEnter} multiline/>
					</div>
					{
						!isMobile && <div className='flexAutoCol pdngXS emojiIconCntnr' >
							<div className='flexAutoCol emojiCntnr' ref={emojiRef} onKeyPress={handleEmojisEnter}>
								{showEmojis &&
								<EmojiPicker native emojiStyle={EmojiStyle.GOOGLE} className='emojiPopup' lazyLoadEmojis onEmojiClick={handleChatEmojis} previewConfig={preview}/>							}
							</div>
							{showEmojis ?
								<CloseIcon
									onClick={() => setShowEmojis(false)}
									fontSize='medium'
									className='pointer icons1'
								/> :
								<img className='pointer icons1' src='icons/Icon.svg' alt='icons' onClick={() => setShowEmojis(true)} />
							}
						</div>}
					<div className={`flexAutoCol pdngXS ${enterEnable && 'disable'}`} >
						<img className='pointer icons2' src='icons/send.svg' alt='icons' onClick={sendMessage} />
					</div>

				</div>
			}
			<ToastContainer
				position='top-right'
				autoClose={3000}
				hideProgressBar={false}
				newestOnTop={false}
				closeOnClick
				rtl={false}
				pauseOnVisibilityChange
				draggable
				pauseOnHover
			/>
		</div>
	);
};

BroadcastInput.propTypes =
{
	roomClient           : PropTypes.object.isRequired,
	displayName          : PropTypes.string,
	peerId               : PropTypes.string.isRequired,
	email                : PropTypes.string,
	picture              : PropTypes.string,
	canChat              : PropTypes.bool.isRequired,
	canShare             : PropTypes.bool.isRequired,
	classes              : PropTypes.object.isRequired,
	browser              : PropTypes.object.isRequired,
	canShareFiles        : PropTypes.bool.isRequired,
	chat                 : PropTypes.any.isRequired,
	files                : PropTypes.any.isRequired,
	toolAreaOpen         : PropTypes.bool.isRequired,
	templateIsFileShare  : PropTypes.bool,
	templateSendFiles    : PropTypes.bool,
	hasInputFileShare    : PropTypes.bool,
	templateChatMsgs     : PropTypes.bool,
	handleChatEmojis     : PropTypes.func.isRequired,
	emojiSelected        : PropTypes.any.isRequired,
	openChatEmoji        : PropTypes.bool.isRequired,
	selectedChatEmoji    : PropTypes.any.isRequired,
	addBroadcastFile     : PropTypes.func.isRequired,
	isModerator          : PropTypes.bool,
	hostControlSendChat  : PropTypes.bool,
	hostControlSendFiles : PropTypes.bool,
	webinarUser          : PropTypes.any,
	webinarData        	 : PropTypes.any,
	socketId             : PropTypes.any,
	isMobile             : PropTypes.bool,
	replyData            : PropTypes.any,
	setReplyData         : PropTypes.any
};

const makeMapStateToProps = () =>
{
	const hasPermission = makePermissionSelector(permissions.SEND_CHAT);
	const filePermission = makePermissionSelector(permissions.SHARE_SCREEN);
	const hasModeratorPermission = makePermissionSelector(permissions.MODERATE_ROOM);

	const mapStateToProps = (state) =>
		({
			displayName          : state.settings.displayName,
			peerId               : state.me.id,
			email                : state.me.email,
			picture              : state.me.picture,
			socketId             : state.me.socketId,
			canChat              : hasPermission(state),
			canShare             : hasPermission(state),
			hasInputFileShare    : filePermission(state),
			browser              : state.me.browser,
			canShareFiles        : state.me.canShareFiles,
			chat                 : state.chat,
			files                : state.files,
			webinarData          : state.webinar.webinarData,
			toolAreaOpen         : state.toolarea.toolAreaOpen,
			templateIsFileShare  : state.toolarea.toolAreaOpen,
			templateSendFiles    : state.toolarea.templateSendFiles,
			templateChatMsgs     : state.toolarea.templateChatMsgs,
			handleChatEmojis     : state.toolarea.handleChatEmojis,
			emojiSelected        : state.room.emojiSelected,
			openChatEmoji        : state.toolarea.openChatEmoji,
			selectedChatEmoji    : state.toolarea.selectedChatEmoji,
			isModerator          : hasModeratorPermission(state),
			hostControlSendChat  : state.toolarea.hostControlSendChat,
			hostControlSendFiles : state.toolarea.hostControlSendFiles,
			isMobile             : state.me.browser.platform === 'mobile'

		});

	return mapStateToProps;
};

const mapDispatchToProps = (dispatch) => ({
	handleChatEmojis : (handleChatEmojis) =>
		dispatch(toolareaActions.handleChatEmojis(handleChatEmojis)),
	addBroadcastFile : (file) =>
		dispatch(fileActions.addBroadcastFile(file))
});

export default withRoomContext(
	connect(
		makeMapStateToProps,
		mapDispatchToProps,
		null,
		{
			areStatesEqual : (next, prev) =>
			{
				return (
					prev.room === next.room &&
					prev.me.email === next.me.email &&
					prev.me.socketId === next.me.socketId &&
					prev.me.browser === next.me.browser &&
					prev.me.roles === next.me.roles &&
					prev.me.canShareFiles === next.me.canShareFiles &&
					prev.peers === next.peers &&
					prev.settings.displayName === next.settings.displayName &&
					prev.me.picture === next.me.picture &&
					prev.chat === next.chat &&
					prev.files === next.files &&
					prev.toolarea.toolAreaOpen === next.toolarea.toolAreaOpen &&
					prev.toolarea.templateIsFileShare === next.toolarea.templateIsFileShare &&
					prev.toolarea.templateSendFiles === next.toolarea.templateSendFiles &&
					prev.toolarea.templateChatMsgs === next.toolarea.templateChatMsgs &&
					prev.toolarea.handleChatEmojis === next.toolarea.handleChatEmojis &&
					prev.toolarea.handleChatEmojis === next.toolarea.handleChatEmojis &&
					prev.room.emojiSelected === next.room.emojiSelected &&
					prev.toolarea.openChatEmoji === next.toolarea.openChatEmoji &&
					prev.toolarea.selectedChatEmoji === next.toolarea.selectedChatEmoji &&
					prev.toolarea.hostControlSendChat === next.toolarea.hostControlSendChat &&
					prev.webinar.webinarData === next.webinar.webinarData &&
					prev.toolarea.hostControlSendFiles === next.toolarea.hostControlSendFiles
				);
			}
		}
	)(withStyles(styles)(BroadcastInput))
);
